module.exports = __webpack_public_path__ + "media/stop-4.81fccfe1.mp3";